// Global packages and functions
import { useState, useEffect, useCallback } from 'react'

// Types
import type { RefObject } from 'react'

// Main export
const useTruncated = ({ ref }: { ref: RefObject<HTMLDivElement> }) => {
  // Local state
  const [isTruncated, setIsTruncated] = useState(false)
  const [isShowingMore, setIsShowingMore] = useState(false)

  // Determine if the ref passed should be truncated or not
  const shouldTruncate = useCallback(() => {
    const { offsetHeight, scrollHeight } = ref.current || {}

    if (offsetHeight && scrollHeight && offsetHeight < scrollHeight) {
      setIsTruncated(true)
    } else {
      setIsTruncated(false)
    }
  }, [ref])

  // Run on load
  useEffect(() => {
    shouldTruncate()
  }, [shouldTruncate])

  // User controlled show/hide
  const toggleIsShowingMore = () => setIsShowingMore(prev => !prev)

  return {
    isTruncated,
    isShowingMore,
    toggleIsShowingMore,
    shouldTruncate,
  }
}

export default useTruncated
